import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { loadUser } from './services/users/user.actions';
import { AuthService } from './services/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  isLoggedIn = false;
  constructor(
    private store: Store,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.isLoggedIn = this.authService.isAuthenticated();

    if (this.isLoggedIn) {
      this.store.dispatch(loadUser());
    }

    this.authService.loginStatusChanged$.subscribe(() => {
      this.store.dispatch(loadUser());
    });
  }
}
